const AddEditReportGroupsParamsDefinitions = [
  {
    section: 'groupDetails',
    tag: 'groupName',
    label: 'Group Name',
    type: 'text',
  },
  {
    section: 'distributionList',
    tag: 'emailInput',
    label: 'Email',
    type: 'custom',
  },
  {
    section: 'distributionList',
    tag: 'distributionList',
    label: 'Recipients',
    type: 'custom',
  },
  {
    section: 'selections',
    tag: 'rigs',
    label: 'Rigs',
    type: 'custom',
  },
  {
    section: 'selections',
    tag: 'reportTypes',
    label: 'Report Types',
    type: 'custom',
  },
  {
    section: 'schedule',
    tag: 'enabled',
    label: 'Enabled',
    type: 'boolean',
  },
  {
    section: 'schedule',
    tag: 'frequency',
    label: 'Frequency',
    type: 'dropDown',
    dropDownOptions: ['Daily', 'Weekly', 'Monthly'],
  },
  {
    section: 'schedule',
    tag: 'time',
    label: 'Time',
    type: 'custom',
  },
  {
    section: 'schedule',
    tag: 'day',
    label: 'Day',
    type: 'dropDown',
    dropDownOptions: [],
  },
]

export function getDetails(form, duplicateGroupName, renderers = {}) {
  const details = {
    groupDetails: [],
    distributionList: [],
    selections: [],
    schedule: [],
  }

  if (!form || typeof form !== 'object') return details

  AddEditReportGroupsParamsDefinitions.forEach((field, index) => {
    if (field.tag === 'day' && form.frequency !== 'Weekly' && form.frequency !== 'Monthly') {
      return
    }

    const value = form[field.tag] === undefined || form[field.tag] === null ? '' : form[field.tag]

    details[field.section].push({
      ...field,
      id: index,
      value,
      ...(field.tag === 'groupName' && {
        error: duplicateGroupName,
        helperText: duplicateGroupName ? 'Group name already exists' : '',
      }),
      ...(field.tag === 'day' && {
        dropDownOptions:
          form.frequency === 'Weekly'
            ? ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
            : Array.from({ length: 31 }, (_, index) => String(index + 1)),
      }),
      ...(field.type === 'custom' && {
        render: renderers[field.tag],
      }),
    })
  })

  return details
}

export default AddEditReportGroupsParamsDefinitions
